export const LocalForageKeys = {
  SigninForm: {
    email: "82244417f956ac7c599f191593f7e441a4fafa20a4158fd52e154f1dc4c8ed92",
    password: "5e884898da28047151d0e56f8dc6292773603d0d6aabbdd62a11ef721d1542d8",
  },
  LoginDialog: {
    TrialBannerDialog: "TrialBannerDialog3",
    AdsReleaseBannerDialog: "AdsReleaseBannerDialog1",
    InterviewRecruitDialog: "InterviewRecruitDialog1",
    UpdateNoticeDialog: "UpdateNoticeDialog202609",
    SecurityNoticeDialog: "SecurityNoticeDialog202610",
    // インサイト取得不可の案内(sessionStorage のキーの接頭辞。後ろにアカウント ID を付ける)
    InsightsUnavailableDialog: "InsightsUnavailableDialog",
  },
  Benchmark: {
    // 競合1社AI解説の表示復元用(「1日1回」制限の真実源はサーバー側日次キャッシュ)。
    // 実キーは utils/benchmark-ai-cache.ts で prefix:igId:account:日付 に組み立てる
    AccountAiInsight: "benchmarkAccountAiInsight1",
  },
} as const;
